export const ACTIONS = {
  STATUS: 'loader/loading_status',
};

export const statusLoading = status => ({ type: ACTIONS.STATUS, payload: status });
